'use strict';

ngtk.Config = Class({
    _config: undefined,

    /**
     * @param {object=} config
     */
    construct: function(config) {
        if (config) {
            this.set(config);
        }
    },

    /**
     * @param {object} config
     */
    set: function(config) {
        this._config = config;
    },

    /**
     * @param {string} path
     * @returns {boolean}
     */
    has: function(path) {
        return !angular.isUndefined(this._findByPath(path));
    },

    /**
     * @param {string} path
     * @param {*} [defaultValue]
     * @returns {*}
     */
    get: function(path, defaultValue) {
        var result = this._findByPath(path);
        return angular.isUndefined(result) ? defaultValue : result;
    },

    /**
     * @param {string} path
     * @returns {*}
     */
    require: function(path) {
        var result = this._findByPath(path);
        if (angular.isUndefined(result)) {
            throw new Error("Missing required configuration item: [" + path + "]");
        }
        return result;
    },

    /**
     * @param {string} path
     * @returns {*}
     * @private
     */
    _findByPath: function(path) {
        var ptr = this._config;
        var key;
        path = angular.isArray(path) ? path : path.split('.');
        while (!angular.isUndefined(ptr) && !angular.isUndefined(key = path.shift())) {
            ptr = ptr[key];
        }
        return ptr;
    }
});
